<template>
  <section>
    <gs-header title="Thêm mới tỉnh thành"
      :breadcrumbs="[
        {title: 'Quản lý tỉnh thành', route: {name: 'city'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localCity" :rules="rules" ref="createCityForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitCity('createCityForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localCity.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Tên viết tắt" prop="short_name">
              <el-input v-model="localCity.short_name" placeholder="Tên viết tắt"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mã bưu chính " prop="code">
              <el-input v-model="localCity.code" placeholder="Mã bưu chính"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="Chọn vùng miền" prop="region_id">
              <el-select v-model="localCity.region_id" filterable placeholder="Chọn vùng miền" class="width-100">
                <el-option
                  label="Chọn vùng miền"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.name"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Lấy hàng " prop="allow">
              <el-checkbox v-model="localCity.allow">Lấy hàng</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-for="(carrier, index) in listCarriers" :key="index">
            <el-form-item :label="carrier.name" :key="localCity[carrier.key]">
              <el-input v-model="localCity[carrier.key]" :placeholder="carrier.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Danh sách vùng miền">
              <el-select
                class="width-100"
                v-model="localCity.regions"
                multiple
                filterable
                placeholder="Danh sách vùng miền"
                >                
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.name"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Các loại tên" prop="map_name">
              <el-select
                v-model="mapNames"
                multiple
                filterable
                allow-create
                default-first-option
                :reserve-keyword="false"
                placeholder="Chọn các loại tên cho tỉnh thành phố"
                style="width: 100%"
                no-data-text="Không có dữ liệu"
                @change="handleChange"
              >             
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { addCity } from 'src/api/city'
import { head } from 'lodash'
import mixins from './mixins'
export default {

  name: 'NewCity',
  mixins: [mixins],
  data () {
    return {}
  },
  methods: {
    validateBeforeSubmitCity () {
      this.submitting = true
      this.toggleLoadding()
      this.localCity.map_names = this.mapNames
      this.$refs.createCityForm.validate(valid => {
        if (valid) {
          this.changedData = false
          addCity(this.localCity).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm tỉnh thành thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'city'}, 'cities')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    },
    newCity () {
      this.localCity = {
        name: '',
        allow: false,
        short_name: '',
        region_id: 0,
        code: '',
        regions: []
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewCity.vue?72137d4d